import React, { useEffect, useState, useCallback, useMemo } from "react";
import { IAgeConfirmation } from "@/interfaces/ageConfimation";
import "./style.scss";

interface Props {
  ageConfirmation: IAgeConfirmation;
  logo: string;
  altLogo: string;
  defaultValues: DefaultValues;
}

interface DefaultValues {
  title: string;
  yes: string;
  no: string;
  message_error: string;
  description: string;
}

const LOCAL_STORAGE_KEY = "@planne/virgo-a_age-confirmation";

const AgeConfirmation = (props: Props) => {
  const { ageConfirmation, logo, altLogo, defaultValues } = props;
  const [isBrowser, setIsBrowser] = useState(false);
  const [userAnswer, setUserAnswer] = useState<"under" | "legal" | null>(null);

  const hasAlreadyBeenShown = useMemo(
    () =>
      isBrowser &&
      JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY) || "false"),
    [isBrowser]
  );

  const handleOfLegalAge = useCallback(() => {
    localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(true));
    setUserAnswer("legal");
  }, [isBrowser]);

  useEffect(() => {
    setIsBrowser(true);
  }, []);

  if (hasAlreadyBeenShown || userAnswer === "legal" || !isBrowser) return null;

  return (
    <div className="age-confirmation">
      <img src={logo} alt={altLogo} />
      <h1 className="age-confirmation_title">
        {ageConfirmation.title ?? defaultValues.title}
      </h1>
      {userAnswer !== "under" ? (
        <div className="age-confirmation_buttons">
          <button onClick={handleOfLegalAge}>{defaultValues.yes}</button>
          <button onClick={() => setUserAnswer("under")} className="under_age">
            {defaultValues.no}
          </button>
        </div>
      ) : (
        <div className="age-confirmation_underage">
          {ageConfirmation.messageError ?? defaultValues.message_error}
        </div>
      )}

      <div className="age-confirmation_details">
        {ageConfirmation.description ?? defaultValues.description}
      </div>
    </div>
  );
};

export default AgeConfirmation;
